// Pure helpers for SearchableMultiSelect — kept React-free so the search and
// selection ordering can be unit-tested (the app has no DOM test environment).

export type MsOption = { value: string; label: string; subtitle?: string };

/** Options whose label or subtitle contains `query` (case-insensitive, trimmed).
 *  An empty/whitespace query returns every option. */
export function filterMsOptions(options: MsOption[], query: string): MsOption[] {
  const q = query.trim().toLowerCase();
  if (!q) return options;
  return options.filter(
    (o) => o.label.toLowerCase().includes(q) || (o.subtitle?.toLowerCase().includes(q) ?? false),
  );
}

/** The members of `selected`, re-ordered to follow `allValues` order, so the
 *  emitted array is deterministic (configured options first, not-set last when
 *  it is appended to `allValues`). Values not present in `allValues` are dropped. */
export function orderedSelected(allValues: string[], selected: Set<string>): string[] {
  return allValues.filter((v) => selected.has(v));
}
